import { h } from 'preact';
import * as BaseComp from 'components/bolt/footer/footer.js';
import Store from 'store/store';
import { accessNested, joinClasses, sortObjectByOrder } from 'utils/utils';

import Button from 'components/bolt/button/button';
import Close from 'components/bolt/icons/close';

import s from 'components/bolt/footer/footer.sss';

export default class Footer extends BaseComp.default {
	onLinkClick = (e) => {
		Store.emit('TRACK_FOOTER_LINK_CLICK', { type: 'legal', link: e.ariaLabel });
	};

	onSocialLinkClick = (network) => {
		Store.emit('TRACK_FOOTER_LINK_CLICK', { type: 'social', link: network });
	}

	renderOpenFooter() {
		const { logos, links, copyright, socialLinks } = this.footerData;

		const footerBgStyling = accessNested(Store.get(), 'appData.styling.variables.footerBgColor', this.state.backgroundColor);
		const accessibilityCopy = accessNested(Store.get(), 'appData.copy.accessibilityCopy', {});
		const disclaimer = accessNested(Store.get(), 'appData.copy.baseCopy.footerDisclaimer', '');

		const autoExpanding = this.state.autoExpanding;

		const footerStyle = {
			background: !this.pressKitFooter && footerBgStyling,
		};

		return (
			<div class={joinClasses(s.openWrapper, autoExpanding && s.autoExpanding)} style={footerStyle}>
				<Button
					class={s.closeBtn}
					trigger={autoExpanding ? this.cancelAutoExpanding : this.toggleFooter}
					ariaLabel={accessibilityCopy.$COLLAPSE_FOOTER_ARIA}
				>
					<Close />
				</Button>
				<div class={joinClasses(s.studioDetails)}>
					{this.getLogos(logos)}
					<div class={s.line} />
					<ul class={s.links}>{this.renderLinks(links, 'link')}</ul>
				</div>
				<div class={s.socialLinks}>
					{socialLinks &&
						socialLinks.map((link, i) => {
							return (
								<a
									onClick={() => { this.onSocialLinkClick(link.network) }}
									key={`${link.network}-${i}`}
									href={link.link}
									target="_blank"
									rel="noopener noreferrer"
									aria-label={link.network}
									class={s.socialLink}
								>
									<img alt={`${link.network} icon`} src={`${__IMAGE_ROOT__}/icon_${link.network}.svg`} />
								</a>
							);
						})}
				</div>
				<ul class={joinClasses(s.copyright, this.fontStyles.footerCopyright)}>{this.renderLinks(copyright, 'copyright')}</ul>
				<p class={s.disclaimer}>{disclaimer}</p>
			</div>
		);
	}
}
